<template>
  <div v-if="finish" class="finish">
    <div>SUCCESS</div>
    <div>your Code is {{ code }}</div>
  </div>
  <div v-if="!started" id="start" class="button" @click="start">START</div>

  <template v-if="started">
    <div>Score: {{ score }}</div>
    <!-- <div>Level: {{ stage }}</div> -->
    <div>hideTime: {{ hideTime }}ms</div>
    <div>showTime: {{ showTime }}ms</div>
    <div id="container" :style="{ width: 60 * this.x + 'px' }">
      <div
        class="cell"
        v-for="(value, index) in tisch"
        :key="index"
        @click="select(index)"
      >
        <div
          class="front"
          :class="[value == 1 || value == 2 ? 'rotate180' : '']"
        ></div>
        <div
          class="back"
          :style="[value == 2 ? 'background:red' : '']"
          :class="[value == 1 || value == 2 ? 'rotate0' : '']"
        ></div>
      </div>
    </div>
  </template>
</template>

<script>
// import Countdown from "./Countdown.vue";

export default {
  name: "Mosaic",
  components: {
    // Countdown,
  },
  props: {
    setup: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tisch: [],
      x: 4,
      y: 4,
      klasse: false,
      preSelection: [],
      preSelectionAmount: 3,
      preSelectionAmountMax: 8,
      wrong: 0,
      correct: 0,
      block: false,
      stage: 0,
      score: 0,
      seconds: 10,
      finish: false,
      maxlevel: 2,
      showTime: 2000,
      showTimeStep: 150,
      showTimeMin: 500,
      hideTime: 1500,
      hideTimeStep: 100,
      hideTimeMin: 700,
      goal: 100,
      code: "0X",
      started: false,
      toleranz: 2,
    };
  },
  //0 show back
  //1 show green = correct
  //2 show red = wrong
  methods: {
    start() {
      this.started = true;
      this.init();
    },
    updateScore() {
      this.score += 10;
    },
    startNew() {
      this.init();
    },
    nextStage() {
      if (this.score >= this.goal) {
        //player has won
        this.won();
        return;
      }
      // this.updateScore();
      console.log("next Stage");
      this.hide();

      this.block = true;

      this.wrong = 0;
      this.correct = 0;
      this.preSelection = [];

      if (this.stage < this.maxlevel) {
        this.stage++;
        setTimeout(() => {
          if (this.stage % 2) {
            this.x++;
          } else {
            this.y++;
          }
          //draw new grid
          this.hide();

          setTimeout(() => {
            this.init();
          }, 1500);
        }, 500);
      } else {
        //reduce showTime, but not to much

        if (this.showTime > this.showTimeMin) {
          this.showTime -= this.showTimeStep;
          if (this.showTime < this.showTimeMin) {
            this.showTime = this.showTimeMin;
          }
        }
        //draw new grid
        this.hide();
        setTimeout(() => {
          this.init();
        }, this.hideTime);
      }

      if (this.preSelectionAmountMax > this.preSelectionAmount) {
        this.preSelectionAmount++;
      }
    },
    hide() {
      // console.log(this.x);
      // console.log(this.y);
      this.tisch = new Array(this.y * this.x).fill(0);
    },
    init() {
      this.finish = false;
      this.block = true;
      this.tisch = new Array(this.y * this.x).fill(0);

      //get 5 random numbers and preselect them
      this.preSelection = this.randomUniqueIntegers(
        this.x * this.y,
        this.preSelectionAmount
      );
      this.preSelection.forEach((n) => {
        this.tisch[n] = 1;
      });

      setTimeout(() => {
        this.hide();
        this.block = false;
      }, this.showTime);
    },
    select(i) {
      if (this.block) return;
      if (this.tisch[i] == 1) return;
      if (this.preSelection.includes(i)) {
        //user has clicked the correct tile
        this.tisch[i] = 1;
        this.correct++;
        this.updateScore();
        if (this.correct === this.preSelection.length) {
          this.block = true;
          setTimeout(() => {
            this.nextStage();
            //reduce hideTime, but not to much
            if (this.hideTime > this.hideTimeMin) {
              this.hideTime -= this.hideTimeStep;
              if (this.hideTime < this.hideTimeMin) {
                this.hideTime = this.hideTimeMin;
              }
            }
          }, this.hideTime);
        }
      } else {
        //wrong tile
        this.tisch[i] = 2;
        this.wrong++;
        if (this.wrong >= this.toleranz) {
          this.loose();
        }
      }
    },
    won() {
      console.log("win");
      this.finish = true;
      //win animation TODO
    },
    loose() {
      console.log("loose");
      this.reload();
    },
    reset() {
      //reset variables
      //load the setup again
      if (this.setup) {
        console.log("LOADING SETUP");

        for (const key in this.setup) {
          this[key] = this.setup[key];
        }
      }
      this.wrong = 0;
      this.score = 0;
      this.correct = 0;
      this.preSelection = [];
      this.block = true;
      this.stage = 0;

      console.log("Correct after reset" + this.correct);
    },
    reload() {
      //flip all tiles to red
      this.tisch = new Array(this.y * this.x).fill(2);
      setTimeout(() => {
        console.log("reset");
        this.reset();
        this.hide();
        setTimeout(() => {
          this.block = false;
          this.init();
        }, 2000);
      }, 2000);
    },
    wenden() {
      this.klasse = !this.klasse;
    },
    randomUniqueIntegers(total, quantity) {
      const numbers = Array(total)
        .fill(null)
        .map((_, i) => i);

      return numbers
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value)
        .slice(0, quantity);
    },
  },
  created() {
    //fill in the setup
    if (this.setup) {
      console.log("LOADING SETUP");

      for (const key in this.setup) {
        this[key] = this.setup[key];
      }
    }
  },
};
</script>

<style scoped>
* {
  --width: 50px;
}
.cell {
  width: var(--width);
  aspect-ratio: 1;
  margin: 5px;
}

#container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;
  border: 3px solid;
  padding: 5px;
}

.selected {
  background: var(--orange);
}
.front,
.back {
  width: var(--width);
  aspect-ratio: 1;
  position: absolute;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  transition: ease-in-out 250ms;
}

.front {
  background: #9e9e9e;
  cursor: pointer;
}

.back {
  background: lime;
  transform: rotateY(-180deg);
}

.rotate0 {
  transform: rotateY(0deg);
}

.rotate180 {
  transform: rotateY(180deg);
}

.finish {
  position: absolute;
  background: rgb(253 124 50 / 95%);
  width: 300px;
  height: 300px;
  left: 50%;
  transform: translate(-50%, 0px);
  z-index: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  color: white;
  font-size: 30px;
  font-weight: 900;
}
</style>
